import { createSlice } from "@reduxjs/toolkit";
import { getAuthProps, setAuthProps, signOut } from "../../lib/authenticationLibrary";

const authData = getAuthProps();

const authSlice = createSlice({
    name: 'auth',
    initialState: {
        isAuthenticated: (authData != null),
        user: (authData?.user), //Set user data from cookie.
        token: (authData?.token), //Set token data from cookie.
        authData,
        navigationMenuList: [],
        isLogedin: false,
        isPasswordResetRequired: false
    },

    reducers: {
        authentication: (state, action) => {
            const { securityResponses, ...newAuthProps } = action.payload;
            setAuthProps(newAuthProps);

            const { isAuthenticated, user } = action.payload;

            const { passwordResetRequired } = user;

            state.isLogedin = true;
            state.isAuthenticated = isAuthenticated;
            state.isPasswordResetRequired = passwordResetRequired ? passwordResetRequired : false
        },
        logout: (state) => {
            state.isLogedin = false;
            signOut();
        },
    },
});

export const { authentication, logout } = authSlice.actions;

export default authSlice.reducer;